import * as React from "react";
import styled from "styled-components";
import { RadioGroup, Checkbox } from "@conserveit/blocks";
import { OPTIONS } from "./SettingsBox";
import { InsightType } from "../../../utils/routes";
import { FieldLabel, CheckboxWrap } from "./Box.styles";

const Wrapper = styled.div`
  label {
    display: block;
    margin-bottom: 8px;
  }

  label span {
    display: inline-block;
  }
`;

interface Props {
  active: number;
  onChange(option: any): void;
  insightType: InsightType;
}

export const PriorityControl: React.FC<Props> = (props) => {
  if (props.insightType === InsightType.Monitoring) {
    return (
      <>
        <FieldLabel>Response Priority</FieldLabel>
        <Wrapper>
          <RadioGroup
            name="priority-radio"
            options={OPTIONS}
            onChange={(option) => {
              props.onChange(option);
            }}
            value={props.active}
            defaultValue={props.active}
          />
        </Wrapper>
      </>
    );
  } else {
    return (
      <CheckboxWrap>
        <Checkbox
          label="Prioritise"
          checked={props.active === 1}
          name="SelectedRuleCheckbox"
          onChange={(event) => {
            props.onChange(event.target.checked ? 1 : 0);
          }}
        />
      </CheckboxWrap>
    );
  }
};
